import { Component } from '@angular/core';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';

@Component({
  selector: 'app-user-access-details-default',
  templateUrl: './user-access-details-default.component.html',
  styleUrls: ['./user-access-details-default.component.scss'],
})
export class UserAccessDetailsDefaultComponent {
  readonly LANG_CONST = LANG_CONST;

  constructor() {}
}
